module.exports = __webpack_public_path__ + "static/media/movistar-logo.54bc2819.png";